import type { FaireProductEntity } from "../../entity_types/product";

export const p_9ebda6svmo: FaireProductEntity = {
  token: "p_9ebda6svmo",
  type: "product",
  name: "15mm Solid Miami Cuban Link Chain Necklace & Bracelet Set",
  brandToken: "b_es7mn9nt",
  brandName: "EMESLY",
  imageUrl:
    "https://cdn.faire.com/fastly/5cd363584fee3e6b2710f9371a0cf4de6b1e11afdedc7af44786e4a4d70ff5a3.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4ce734d56560b7c488c9f2a576daeec9cb9affb0ca42056c72140d61a8fb050f.png",
    "https://cdn.faire.com/fastly/0c72ee5224282a09360934e2554872e0bcff5da91f1f551a4d2a2c50dc7bf0ae.png",
    "https://cdn.faire.com/fastly/8096635bd144e64f06e44be01664c161e9d34188980a5b5a650d2302285519ce.png",
    "https://cdn.faire.com/fastly/cbf794ea3ea342904ebc35df5eea568a13d282c300997089053b874780e26309.png",
    "https://cdn.faire.com/fastly/f51a3ce175c9c247ad37438a047c4b9f8806b45e2f37fd34fef41b0418a4c732.jpeg",
    "https://cdn.faire.com/fastly/fec0203e26484410f0f5087bfee3fc4a6f316b51c5974dd69338692912bfa6b4.png",
  ],
  priceDollars: 24.99,
  description:
    'Miami Cuban Link Chain Necklace & Bracelet Set - Necklace Length Options: 16" - 30"; Bracelet Length: 7.87" | Give a modern urban edge to a casual t-shirt, hoodie, or formal outfit. Wear solo for an everyday polished look or add a favorite pendant or charm for a cool personal statement.\n\nMaterial: This beautiful necklace and bracelet is gold plated and is crafted to be durable for easy all-day wear. It is nickel and lead-free and has a long-lasting brilliant hypoallergenic high polish finish.',
  tags: [],
  msrpDollars: 49.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:19.423Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
